import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  SAVE_HEALTH_REQUEST: '',
  SAVE_HEALTH_SUCCESS: '',
  SAVE_HEALTH_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityHealth');

export default types;
